import './boot-error-handlers';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './theme.css';
import { initStoredTheme } from './ThemePicker';
import { startTelegramChromeSync } from './telegramChrome';
import App from './App';
import AdminPage from './AdminPage';
import { ErrorBoundary } from './ErrorBoundary';
import reportWebVitals from './reportWebVitals';

function isAdminHash(): boolean {
  return (
    typeof window !== 'undefined' &&
    window.location.hash.replace(/^#/, '').split('?')[0] === 'admin'
  );
}

function Root() {
  const [admin, setAdmin] = React.useState(isAdminHash);
  React.useEffect(() => {
    const onHash = () => setAdmin(isAdminHash());
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);
  return admin ? <AdminPage /> : <App />;
}

initStoredTheme();
startTelegramChromeSync();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Root />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
